import type { ApiBaseUrlType, HeadersOptionType } from '@/uTypes/api'
import { useApiBaseUrl } from '@/uComposables/apiClient/useApiBaseUrl'
import { useApiClient } from '@/uComposables/apiClient/useApiClient'

export default defineNuxtPlugin((nuxtApp) => {
  /**
   * API 인스턴스 맵을 전역 상태로 관리
   * key: apiBaseUrlType (string), value: API 객체 (useApiClient 반환값)
   * Map은 직렬화가 어려우므로 클라이언트에서만 초기화
   */
  const instanceMap = process.client ? new Map<string, ReturnType<typeof useApiClient>>() : null
  const getBaseUrl = useApiBaseUrl()

  const getApiClient = (apiBaseUrlType: ApiBaseUrlType = 'v1', headersOption: HeadersOptionType = {}) => {
    const baseUrl = getBaseUrl(apiBaseUrlType)
    const headersKey = JSON.stringify(headersOption)
    const instanceKey = `${baseUrl}::${headersKey}`

    if (process.client) {
      if (instanceMap && !instanceMap.has(instanceKey)) {
        instanceMap.set(instanceKey, useApiClient(baseUrl, headersOption))
      }

      // 클라이언트는 캐싱된 인스턴스를 반환하거나 새로 생성
      return instanceMap?.get(instanceKey) || useApiClient(baseUrl, headersOption)
    }

    // SSR은 항상 새로운 인스턴스를 반환
    return useApiClient(baseUrl, headersOption)
  }

  nuxtApp.provide('api', { getApiClient })
})
